var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrimary = function SvgPrimary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M2.167 6.5a4.333 4.333 0 1 1 8.666 0 4.333 4.333 0 0 1-8.666 0m5.416 6.41A6.502 6.502 0 0 0 6.5 0a6.502 6.502 0 0 0-1.083 12.91v9.118c0 .6.483 1.083 1.083 1.083s1.083-.483 1.083-1.083z"
  })));
};
export default SvgPrimary;